import { call, put } from 'redux-saga/effects'
import { fetchInterviewRequests, patchInterviewRequest, fetchInterviewRequest } from '../apiModules/interviewRequest'
import { interviewRequestEntities } from '../reducks'

export function* fetchInterviewRequestEntitiesSaga(hiringTeamId, params) {
  const response = yield call(fetchInterviewRequests, hiringTeamId, params)

  if (response.result.length > 0) {
    yield put(interviewRequestEntities.addCollection(response.result))
  }

  return response
}

export function* fetchInterviewRequestEntitySaga(hiringTeamId, interviewRequestId) {
  const response = yield call(fetchInterviewRequest, hiringTeamId, interviewRequestId)
  yield put(interviewRequestEntities.addItem(interviewRequestId, response.result))
  return response
}

export function* updateInterviewRequestEntitySaga(hiringTeamId, interviewRequestId, data) {
  const response = yield call(patchInterviewRequest, hiringTeamId, interviewRequestId, data)
  yield put(interviewRequestEntities.updateItem(interviewRequestId, response.result))
  return response
}
